/*
 * @Descripttion: 离开页面时清除 session 缓存，避免缓存过多导致页面卡顿
 * @Date: 2025-11-06 17:54:42
 */
import { RouteLocationNormalized } from 'vue-router';
import { useFormManageStore } from '@/views/form-manage/src/store/index';

export default async (to: RouteLocationNormalized, _next) => {
  const formManageStore = useFormManageStore();
  if (
    formManageStore.routeQuery &&
    ![
      '/main/form-manage-list',
      '/main/form-add-list',
      '/main/form-add-list-edit'
    ].includes(to.path)
  ) {
    formManageStore.initRouteQuery();
  }

  return Promise.resolve();
};
